import { render, staticRenderFns } from "./ProductStatusConfirmSubmit.vue?vue&type=template&id=76f45415&"
import script from "./ProductStatusConfirmSubmit.vue?vue&type=script&lang=js&"
export * from "./ProductStatusConfirmSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports